<template>
  <div>
    <div class="d-flex align-items-center justify-content-end">
      <span
        class="text-50 d-flex justify-content-center align-items-center text-primary"
        @click="setActivePopUp('edit-rooms')"
        ><i class="fi flaticon-edit me-2" />Edit</span
      >
    </div>
    <Carousel
      v-if="favorites"
      :per-page="screenWidth < 600 ? 3 : 5"
      class="favorite-rooms-carousel"
      name="favorite-rooms-carousel"
    >
      <Slide v-for="(elem, index) in favorites" :key="index">
        <div
          v-if="elem.favorable && elem.favorable_type == 'App\\Models\\Room'"
          class="location-box-room"
          @click="selectRoom(elem, $event, index, true)"
        >
          <div
            :class="`fav-icon ${
              elem.favorable.icon ? elem.favorable.icon : 'flaticon-star'
            }`"
          />
          <span class="fav-text">
            {{ elem.favorable.name }}
          </span>
        </div>
        <div
          v-if="elem.favorable && elem.favorable_type == 'App\\Models\\User'"
          class="location-box-user"
          :style="{
            backgroundImage: `url(${
              elem.favorable.avatar
                ? elem.favorable.avatar
                : '/img/avatars/user-avatar.jpeg'
            })`
          }"
        >
          <span class="fav-text">
            {{ elem.favorable.first_name + " " + elem.favorable.last_name }}
          </span>
        </div>
      </Slide>
      <Slide v-for="(item, index) in exptyPoistions" :key="'exmpty' + index">
        <div
          class="location-box-room add-fav"
          @click="setActivePopUp('manage-rooms')"
        >
          <div class="fav-icon fi flaticon-plus" />
          <span class="fav-text"> Add favorite Room </span>
        </div>
      </Slide>
    </Carousel>
    <CModal
      backdrop="static"
      class="ps__child--consume"
      :visible="popup.activePopUp == 'edit-rooms'"
      add-content-classes="bg-white px-1"
    >
      <div>
        <div class="pt-2 px-2" @click="closeModal()">
          <button
            class="btn bg-gradient-blue text-white rounded-circle px-2 py-1 lh-normal"
          >
            x
          </button>
        </div>
        <div class="d-flex justify-content-center">
          <span class="text-black-50 text-value-xl">Edit Favorites</span>
        </div>
      </div>
      <CRow class="justify-content-center mx-n3 p-0">
        <CCol md="12" class="bg-white">
          <div class="d-flex align-items-center justify-content-center mt-4">
            <div
              class="d-flex align-self-stretch flex-column align-items-center justify-content-center bg-gradient-blue py-3 px-3 rounded cursor-pointer"
              @click="setActivePopUp('manage-rooms')"
            >
              <div class="fav-modal-icon fi flaticon-plus text-white" />
              <div
                class="d-block text-white text-value-sm ms-2 fw-bolder mt-3 text-center"
              >
                Add/Remove <br />
                Favorites
              </div>
            </div>
            <div
              class="d-flex align-self-stretch flex-0 flex-column align-items-center justify-content-center bg-gradient-blue py-3 px-3 rounded ms-2 text-center"
              @click="setActivePopUp('organize-rooms')"
            >
              <div class="fav-modal-icon text-white i flaticon-move" />
              <div class="d-block text-white text-value-sm ms-2 fw-bolder mt-3">
                Manage Order
              </div>
            </div>
          </div>
        </CCol>
      </CRow>

      <template #footer-wrapper>
        <div />
      </template>
    </CModal>
    <CModal
      backdrop="static"
      :visible="popup.activePopUp == 'organize-rooms'"
      class="ps__child--consume"
    >
      <div>
        <div class="pt-2 px-2" @click="closeModal()">
          <button
            class="btn bg-gradient-blue text-white rounded-circle px-2 py-1 lh-normal"
          >
            x
          </button>
        </div>
        <div class="d-flex justify-content-center">
          <h4 class="text-black-50 text-value-xl">
            Organize Favorites Rooms and People
          </h4>
        </div>
      </div>
      <p class="text-value-sm fw-light">
        Add icons to your rooms and drag and drop rooms into the order you like.
        Students/teachers will see these rooms and icons in the same order
        whenever they create a pass.
      </p>

      <div class="d-flex flex-wrap">
        <draggable
          v-show="favorites"
          v-model="reOrderedlist"
          tag="transition-group"
          :component-data="{ name: 'fade' }"
        >
          <template #item="{ element, index }">
            <div :key="element + 'tg-2'" class="drag-cnt">
              <div
                v-if="
                  element.favorable &&
                  element.favorable_type == 'App\\Models\\Room'
                "
                class="location-box-room"
                @click="selectRoom(element, $event, index)"
              >
                <div
                  :class="`fav-icon ${
                    element.favorable.icon
                      ? element.favorable.icon
                      : 'flaticon-plus'
                  }`"
                />
                <span
                  v-if="!element.favorable.icon"
                  class="text-center w-100 text-value-xs"
                >
                  Add icon</span
                >
                <span
                  class="fav-text"
                  :class="{
                    'bg-gradient-blue text-white':
                      iconForm.selectedRoom &&
                      iconForm.selectedRoom.id === element.favorable.id
                  }"
                >
                  {{ element.favorable.name }}
                </span>
              </div>
              <div
                v-if="
                  element.favorable &&
                  element.favorable_type == 'App\\Models\\User'
                "
                class="location-box-user"
                :style="{
                  backgroundImage: `url(${
                    element.favorable.avatar
                      ? element.favorable.avatar
                      : '/img/avatars/user-avatar.jpeg'
                  })`
                }"
              >
                <span class="fav-text">
                  {{
                    element.favorable.first_name +
                    " " +
                    element.favorable.last_name
                  }}
                </span>
              </div>
            </div>
          </template>
        </draggable>
      </div>

      <div class="w-100 d-block pt-2">
        <div
          class="d-flex justify-content-center py-4"
          @click="updateFavoritesOrder"
        >
          <button
            class="mx-2 text-uppercase py-3 px-4 fw-bold btn bg-gradient-blue text-white lh-normal"
          >
            Submit
          </button>
        </div>
      </div>
      <template #footer-wrapper>
        <div />
      </template>
    </CModal>

    <div
      v-show="hasSelected"
      id="iconSelector"
      ref="iconSelector"
      class="icon-library-selector bg-white position-fixed shadow px-3 px-md-4 ps__child--consume"
    >
      <div class="py-2">
        <button
          class="btn bg-gradient-blue text-white rounded-circle px-2 py-1 lh-normal"
          @click="closeIconWindow()"
        >
          x
        </button>
      </div>
      <div class="d-flex justify-content-center">
        <span class="ms-2 text-black-50 text-value-sm"
          >Select icon
          {{ selectedIcon }}
          {{
            iconForm.selectedRoom ? "for " + iconForm.selectedRoom.name : ""
          }}</span
        >
      </div>
      <Carousel
        :per-page="splitby"
        class="favorite-rooms-carousel icon-library-carousel extra-small-size"
        name="favorite-rooms-carousel"
        style="width: 300px"
      >
        <template v-for="(elem, index) of iconsSplit" :key="index">
          <Slide>
            <template v-for="(icon, i) of elem" :key="index + '_' + i">
              <div class="mb-1 d-flex flex-wrap icon-wrap">
                <div
                  v-if="selectedIcon != icon"
                  class="location-box-room"
                  @click="setIcon(icon)"
                >
                  <div :class="`fav-icon ${icon}`" />
                </div>
                <div
                  v-if="selectedIcon == icon"
                  class="location-box-room active"
                  @click="setIcon(icon)"
                >
                  <div :class="`fav-icon ${icon}`" />
                </div>
              </div>
            </template>
          </Slide>
        </template>
      </Carousel>
      <div class="d-flex justify-content-center py-1 pb-3 py-md-4">
        <button
          class="mx-2 text-uppercase py-2 px-3 py-md-3 px-md-4 fw-bold btn bg-gradient-blue text-white lh-normal"
          @click="saveIcon"
        >
          Submit
        </button>
      </div>
      <CAlert
        v-if="iconForm.reqResponse.message"
        class="mt-4 w-100"
        :color="iconForm.reqResponse.type"
        :show="!!iconForm.reqResponse.message"
        close-button
      >
        {{ iconForm.reqResponse.message }}
      </CAlert>
    </div>
    <CModal
      backdrop="static"
      :visible="popup.activePopUp == 'manage-rooms'"
      class="ps__child--consume"
    >
      <div>
        <div class="pt-2 px-2" @click="closeModal()">
          <button
            class="btn bg-gradient-blue text-white rounded-circle px-2 py-1 lh-normal"
          >
            x
          </button>
        </div>
        <div
          class="d-flex justify-content-center align-items-center px-4 px-md-1 text-center mb-1 mb-md-3 mt-2 mt-md-0"
        >
          <span class="text-black-50 text-value-xl"
            >Add/Remove Favorites Rooms and People
            <HelpCenterButton
              classes="ms-2"
              width="18"
              height="18"
              content-key="fav_rooms_help"
          /></span>
        </div>
      </div>

      <div class="w-100 d-block pt-2">
        <!-- <p class="text-value-sm fw-light mb-1">
          Select global favorite rooms. The rooms will be visible as favorite after you submit.
        </p> -->
        <div class="mb-2">
          1. Select global favorite rooms. The rooms will be visible as favorite
          after you submit.
        </div>
        <LazyLoadSelect
          v-if="tempList"
          :classes="'mb-3'"
          :is-multiple="true"
          :selected="tempList"
          type="combined"
          placeholder="Select location"
          :selectable="
            (option) =>
              tempList.length < 10 &&
              !tempList.map((e) => e.value.id).includes(option.value.id)
          "
          @changed="
            (value) => {
              tempList = value
            }
          "
        />
      </div>
      <div class="mb-2">2. List with favorites</div>
      <div class="d-flex flex-wrap favorite-rooms-list">
        <div
          v-for="(elem, index) in reOrderedlist"
          :key="index + 'tg-2'"
          class="drag-cnt"
        >
          <div
            v-if="elem.favorable && elem.favorable_type == 'App\\Models\\Room'"
            class="location-box-room"
            @click="selectRoom(elem, $event, index)"
          >
            <div
              :class="`fav-icon ${
                elem.favorable.icon ? elem.favorable.icon : 'flaticon-plus'
              }`"
            />
            <span
              v-if="!elem.favorable.icon"
              class="text-center w-100 text-value-xs"
            >
              Add icon</span
            >
            <span
              class="fav-text"
              :class="{
                'bg-gradient-blue text-white': elem.selected
              }"
            >
              {{ elem.favorable.name }}
            </span>
          </div>
          <div
            v-if="elem.favorable && elem.favorable_type == 'App\\Models\\User'"
            class="location-box-user"
            :style="{
              backgroundImage: `url(${
                elem.favorable.avatar
                  ? elem.favorable.avatar
                  : '/img/avatars/user-avatar.jpeg'
              })`
            }"
          >
            <span class="fav-text">
              {{ elem.favorable.first_name + " " + elem.favorable.last_name }}
            </span>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center py-4" @click="sumbitFavorites">
        <button
          class="mx-2 text-uppercase py-3 px-4 fw-bold btn bg-gradient-blue text-white lh-normal"
        >
          Submit
        </button>
      </div>
      <template #footer-wrapper>
        <div />
      </template>
    </CModal>
  </div>
</template>

<script>
// import { Carousel, Slide } from "vue-carousel"
import { Carousel, Slide } from "@jambonn/vue-concise-carousel"
import "@jambonn/vue-concise-carousel/lib/vue-concise-carousel.css"
import draggable from "vuedraggable"
import { mapGetters } from "vuex"
import LazyLoadSelect from "../LazyLoadSelect"
import HelpCenterButton from "@/components/HelpCenterButton"

export default {
  name: "RoomsCarousel",
  components: {
    LazyLoadSelect,
    Carousel,
    Slide,
    draggable,
    HelpCenterButton
  },
  emits: ["favorites-updated"],
  data() {
    return {
      splitby: 5,
      icons: [
        "flaticon-washroom",
        "flaticon-waitroom",
        "flaticon-volumedon",
        "flaticon-volumedoff",
        "flaticon-tennis",
        "flaticon-swimming",
        "flaticon-studentworkarea",
        "flaticon-securityoffice",
        "flaticon-printer1",
        "flaticon-painting",
        "flaticon-nurse1",
        "flaticon-music1",
        "flaticon-locker",
        "flaticon-library",
        "flaticon-gym",
        "flaticon-guidanceoffice",
        "flaticon-guidance",
        "flaticon-football",
        "flaticon-drinkingwater",
        "flaticon-discipline",
        "flaticon-computer",
        "flaticon-camera",
        "flaticon-cafeteria",
        "flaticon-auditorium",
        "flaticon-attendance",
        "flaticon-admin",
        "flaticon-dashboard_user",
        "flaticon-idea-gray",
        "flaticon-15-minutes",
        "flaticon-alarm",
        "flaticon-alarm-1",
        "flaticon-book",
        "flaticon-book-1",
        "flaticon-briefcase",
        "flaticon-calculator",
        "flaticon-chat",
        "flaticon-clip",
        "flaticon-coffee-cup",
        "flaticon-coloring-tool",
        "flaticon-compass",
        "flaticon-cut",
        "flaticon-dashboard",
        "flaticon-diagram",
        "flaticon-diamond",
        "flaticon-disabled",
        "flaticon-dumbell-1",
        "flaticon-file",
        "flaticon-flag",
        "flaticon-flag-1",
        "flaticon-flag-2",
        "flaticon-followers",
        "flaticon-forbidden",
        "flaticon-fountain-1",
        "flaticon-graduation-cap",
        "flaticon-headphones",
        "flaticon-heart",
        "flaticon-highlighter",
        "flaticon-home",
        "flaticon-hour-glass",
        "flaticon-information",
        "flaticon-information-circle",
        "flaticon-joke",
        "flaticon-key",
        "flaticon-light-bulb",
        "flaticon-lightbulb",
        "flaticon-lockers",
        "flaticon-lockers-1",
        "flaticon-medal",
        "flaticon-megaphone",
        "flaticon-megaphone-1",
        "flaticon-megaphone-2",
        "flaticon-microphone",
        "flaticon-money",
        "flaticon-monitor",
        "flaticon-moon",
        "flaticon-move",
        "flaticon-music",
        "flaticon-nurse",
        "flaticon-open-book",
        "flaticon-paste",
        "flaticon-photo-camera",
        "flaticon-picture",
        "flaticon-pie-chart",
        "flaticon-piggy-bank",
        "flaticon-printer",
        "flaticon-profile-user",
        "flaticon-push-pin",
        "flaticon-puzzle",
        "flaticon-remove-user",
        "flaticon-rotating-arrows-circle",
        "flaticon-safari",
        "flaticon-scale",
        "flaticon-shield",
        "flaticon-shopping-cart",
        "flaticon-shuffle",
        "flaticon-smartphone",
        "flaticon-smile",
        "flaticon-snowflake",
        "flaticon-star-2",
        "flaticon-sun",
        "flaticon-switch-1",
        "flaticon-tag",
        "flaticon-thermometer",
        "flaticon-thunderbolt",
        "flaticon-toilet",
        "flaticon-tools",
        "flaticon-umbrella",
        "flaticon-user",
        "flaticon-user-1",
        "flaticon-video",
        "flaticon-video-camera",
        "flaticon-volume",
        "flaticon-volume-1",
        "flaticon-wall-clock",
        "flaticon-warning-1",
        "flaticon-warning-2",
        "flaticon-weightlifting-silhouette",
        "flaticon-wind"
      ],
      search: "",
      popup: {
        activePopUp: "edit-destination"
      },
      form: {
        rooms: []
      },
      iconForm: {
        selectedRoom: null,
        reqResponse: {
          type: "",
          message: "",
          errors: {}
        }
      },
      reqResponse: {
        type: "",
        message: "",
        errors: {}
      },
      reOrderedlist: [],
      tempList: [],
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      staff: "users/formListStaff",
      rooms: "rooms/formListRooms",
      fromFavorites: "favorites/fromFavorites"
    }),
    favorites() {
      return this.fromFavorites.filter(
        (e) => e.global && e.section == "destination"
      )
    },
    screenWidth() {
      return window.innerWidth || document.documentElement.clientWidth
    },
    screenHeight() {
      return window.innerHeight || document.documentElement.clientHeight
    },
    exptyPoistions() {
      return Array.from(
        {
          length: 10 - this.favorites.length
        },
        (_, i) => i + this.favorites.length
      )
    },
    isFavLimitReached() {
      return this.tempList.length <= 10 ? false : true
    },
    iconsSplit() {
      // eslint-disable-next-line
      return [].concat.apply(
        [],
        this.icons.map((elem, i) => {
          return i % this.splitby ? [] : [this.icons.slice(i, i + this.splitby)]
        })
      )
    },
    hasSelected() {
      return this.reOrderedlist.filter((e) => e.selected).length > 0
    },
    selectedIcon() {
      return (
        (this.reOrderedlist.filter((e) => e.selected).length > 0 &&
          this.reOrderedlist.filter((e) => e.selected)[0].favorable.icon) ||
        "default"
      )
    }
  },
  watch: {
    fromFavorites() {
      this.updateTempList()
    },
    reOrderedlist() {
      const temp = this.reOrderedlist.filter((e) => e.selected)[0]
      if (temp) {
        this.iconForm.selectedRoom = JSON.parse(JSON.stringify(temp.favorable))
      }
    }
  },
  created() {
    this.$store.dispatch("favorites/getFavorites").then(() => {
      this.updateTempList(this.favorites)
    })
    this.handleIconModalVisibility()
  },
  methods: {
    updateTempList() {
      this.tempList = this.favorites.map((e) => {
        return {
          capacity: true,
          label: e.favorable.name,
          value: {
            id: e.favorable.id,
            type: e.favorable_type
          }
        }
      })
      this.reOrderedlist = JSON.parse(JSON.stringify(this.favorites))
    },
    selectRoom(room, event, index, notManagable) {
      if (notManagable) {
        return
      }
      //TODO: fix selection
      this.reOrderedlist.forEach((e) => {
        e.selected = false
      })
      this.reOrderedlist[index].selected = true
      this.reOrderedlist = JSON.parse(JSON.stringify(this.reOrderedlist))

      if (this.screenWidth > 600) {
        this.$refs.iconSelector.classList.add("opacity-0")
        this.$refs.iconSelector.style.setProperty("top", event.clientY + "px")
        this.$refs.iconSelector.style.setProperty("left", event.clientX + "px")

        setTimeout(() => {
          const iconSelector = this.$refs.iconSelector
          const top = this.isVisibleOnY(iconSelector)
            ? event.clientY
            : event.clientY - this.getPossibleTop(iconSelector)
          const right = this.isVisibleOnX(iconSelector)
            ? event.clientX
            : event.clientX - 350

          iconSelector.style.setProperty("top", top + "px")
          iconSelector.style.setProperty("left", right + "px")
          iconSelector.classList.remove("opacity-0")
        }, 300)
      }
    },
    getPossibleTop(el) {
      const rect = el ? el.getBoundingClientRect() : null
      return rect
        ? rect.bottom -
            (window.innerHeight || document.documentElement.clientHeight)
        : 0
    },
    isVisibleOnY(el) {
      const rect = el ? el.getBoundingClientRect() : null
      return (
        rect &&
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight)
      )
    },
    isVisibleOnX(el) {
      const rect = el ? el.getBoundingClientRect() : null
      return (
        rect &&
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      )
    },
    setIcon(icon) {
      const temp = this.reOrderedlist.filter((e) => e.selected)[0]
      if (temp) {
        temp.favorable.icon = icon
        this.iconForm.selectedRoom = temp.favorable
      }
      this.iconForm.selectedRoom.icon = icon
    },
    saveIcon() {
      const temp = this.reOrderedlist.filter((e) => e.selected)[0]
      this.iconForm.selectedRoom = temp.favorable
      const roomId = temp.favorable.id
      const data = {
        icon: temp.favorable.icon
      }
      this.$store
        .dispatch("rooms/updateRoomIcon", {
          roomId,
          data
        })
        .then(() => {
          this.setIconSuccessResponse("Successfully updated.")
          this.isFormLoading = false

          setTimeout(() => {
            this.$store
              .dispatch("favorites/getFavorites", { clearCacheEntry: true })
              .then(() => {
                this.updateTempList()
                this.$emit("favorites-updated")
              })
            this.$store.commit("rooms/SET_EDITABLE_ROOM", null)
            this.closeIconWindow()
            this.resetResponseMessages()
          }, 500)
        })
        .catch((err) => {
          const response = err.response.data
          this.isFormLoading = false
          this.setIconErrorResponse(response.message, response.errors)
        })
    },
    updateFavoritesOrder() {
      const favForSubmit = this.reOrderedlist.map((e, i) => {
        if (e.value) {
          return {
            id: e.value.id,
            type: e.value.type,
            position: i
          }
        } else {
          return {
            id: e.favorable_id,
            type: e.favorable_type,
            position: i
          }
        }
      })
      this.$store
        .dispatch("favorites/updateFavoriteBulk", {
          elements: favForSubmit,
          section: "destination",
          global: true
        })
        .then(() => {
          this.$store.dispatch("favorites/getFavorites").then(() => {
            this.updateTempList(this.favorites)
            this.$emit("favorites-updated")
            this.closeModal()
          })
        })
    },
    sumbitFavorites() {
      const favForSubmit = this.tempList.map((e, i) => {
        if (e.value) {
          return {
            id: e.value.id,
            type: e.value.type,
            position: i
          }
        } else {
          return {
            id: e.favorable_id,
            type: e.favorable_type,
            position: i
          }
        }
      })
      this.$store
        .dispatch("favorites/updateFavoriteBulk", {
          elements: favForSubmit,
          section: "destination",
          global: true
        })
        .then(() => {
          this.$store.dispatch("favorites/getFavorites").then(() => {
            this.updateTempList(this.favorites)
            this.$emit("favorites-updated")
            this.closeModal()
          })
        })
    },
    closeIconWindow() {
      this.iconForm.selectedRoom = null
      this.iconForm.icon = ""
    },
    setIconSuccessResponse(message) {
      this.iconForm.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
      setTimeout(() => {
        this.resetIconResponseMessages()
      }, 2000)
    },
    setIconErrorResponse(message, errors) {
      this.iconForm.reqResponse = {
        type: "danger",
        message: message ? message : "Something went wrong!",
        errors: errors ? errors : {}
      }
    },
    resetIconResponseMessages() {
      this.iconForm.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    setSuccessResponse(message) {
      this.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
      setTimeout(() => {
        this.resetResponseMessages()
      }, 2000)
    },
    setErrorResponse(message, errors) {
      this.reqResponse = {
        type: "danger",
        message: message ? message : "Something went wrong!",
        errors: errors ? errors : {}
      }
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    setActivePopUp(popup) {
      this.popup.isVisible = true
      this.popup.activePopUp = popup
      this.search = ""
    },
    closeModal() {
      this.popup.activePopUp = ""
      this.closeIconWindow()
    },
    handleIconModalVisibility() {
      document.addEventListener("click", (e) => {
        const isIconPopup = !!(
          e.path &&
          e.path.filter(
            (el) =>
              (el.classList &&
                el.classList.contains("icon-library-selector")) ||
              (el.classList && el.classList.contains("location-box-room"))
          ).length
        )
        if (this.iconForm.selectedRoom && !isIconPopup) {
          this.closeIconWindow()
        }
      })
    }
  }
}
</script>
<style>
.drag-cnt {
  min-width: 120px;
  cursor: pointer;
}

#iconSelector {
  z-index: 999999999;
}
</style>
